import React from "react";
import ReviewView from "./ReviewView";

export const ReviewContainer = (props) => {
  /**
   * 1. page load, get all details of Team members and their punch record for current week (mon-sun).
   * 2. Create UI for Punch records
   * 3. Create UI for Team members
   * 4. Create UI for Manager Contigent workers options
   */

  return <ReviewView />;
};

ReviewContainer.propTypes = {};

export default ReviewContainer;
